const paths = {
  not_found: "/not-found",
  login: "/login",
  home: "/home",
  register: "/cadastro",
  onHolding: "/finalizar-cadastro",
  addBankAccount: "/cadastrar-informacoes-bancarias",
  appointments: {
    list: "/sessoes",
    room: "/sessoes/sala",
  },
  chat: {
    list: "/chat",
  },
  financial: {
    list: "/financeiro",
  },
  more: "/mais",
  psiappPlus: "/psiapp-plus",
  forgot_password: "/esqueci-a-senha",
  reset_password: "/password/reset",
  stripe_connect: "/stripe-connect",
};

export default paths;
